import { useCallback, useState } from 'react'

import { useAppDispatch } from 'cng-common/hooks/useAppDispatch'
import { PLAN_FINANCIALS_TAG, planFinancialsApi } from 'partner360/entities/planFinancials'

import type { ApplySobActualsReviewParams } from '../api/applySobActualsReview'
import { applySobActualsReview } from '../api/applySobActualsReview'

export const useApplySobActualsReview = () => {
  const [isApplyingSobActualsReview, setIsApplyingSobActualsReview] = useState(false)
  const [hasApplySobActualsReviewError, setHasApplySobActualsReviewError] = useState(false)
  const dispatch = useAppDispatch()

  const submitSobActualsReview = useCallback(
    async (params: ApplySobActualsReviewParams) => {
      setIsApplyingSobActualsReview(true)
      setHasApplySobActualsReviewError(false)

      try {
        await applySobActualsReview(params)
        // Saved SOB values would otherwise be served from the cached spJBPPartnerFinSobData
        // response the next time the modal is opened, until a full page reload
        dispatch(planFinancialsApi.util.invalidateTags([PLAN_FINANCIALS_TAG]))

        return true
      } catch {
        setHasApplySobActualsReviewError(true)
        return false
      } finally {
        setIsApplyingSobActualsReview(false)
      }
    },
    [dispatch]
  )

  return {
    submitSobActualsReview,
    isApplyingSobActualsReview,
    hasApplySobActualsReviewError,
  }
}
